import { ProfanityStore } from "@fidget/common/models/profanities/ProfanityStore";
import { FeaturesStore } from "@fidget/common/models/features/FeaturesStore";
import { extendsSharedRootStore, SharedRootStoreEnv } from "@fidget/common/models/shared/sharedEnv";
import { UserActivityService } from "@fidget/common/services/userActivityService";
import { MobXProviderContext } from "mobx-react";
import { Instance, types } from "mobx-state-tree";
import { useContext } from "react";
import { PluginService } from "../plugins/pluginService";
import { RingtoneService } from "../services/ringtoneService";
import { SpinnerService } from "../services/spinner/spinnerService";
import { AgentStore } from "./agent";
import { AgentGroupStore } from "./agentGroups/agentGroupsStore";
import { AgentServices } from "./agentServices";
import { CalendarStore } from "./calendar";
import { CallStore } from "./call";
import { CobrowsingStore } from "./cobrowsing";
import { CurrentUserStore } from "./currentUser";
import { InboxStore } from "./inbox";
import { IntentStore } from "./intent";
import { MessageWidgetsStore } from "./messageWidgets/MessageWidgetsStore";
import { PaymentStore } from "./payments";
import { ReportsStore } from "./reports/reportsStore";
import { RoleStore } from "./role/RoleStore";
import { RoomStore } from "./room";
import { RouterStore } from "./router";
import { TagGroupsStore } from "./tagGroups/TagGroupStore";
import { TagsStore } from "./tags/TagsStore";
import { TopicStore } from "./topics/topicStore";
import { UiStore } from "./ui";
import { WidgetStore } from "./widget";
import { GuestStore } from "./guest/GuestStore";
import { UsersStore } from "./users/UsersStore";
import { TagGroupRulesStore } from "./transferRules/TagGroupRulesStore";
import { AgentCallService } from "../services/AgentCallService";

export const RootStore = types.model("RootStore", {
  routerStore: RouterStore,
  agentStore: AgentStore,
  inboxStore: InboxStore,
  roomStore: RoomStore,
  calendarStore: CalendarStore,
  callStore: CallStore,
  currentUserStore: CurrentUserStore,
  uiStore: UiStore,
  intentStore: IntentStore,
  widgetStore: WidgetStore,
  paymentStore: PaymentStore,
  cobrowsingStore: CobrowsingStore,
  profanityStore: ProfanityStore,
  reportsStore: ReportsStore,
  tagsStore: TagsStore,
  tagGroupsStore: TagGroupsStore,
  roleStore: RoleStore,
  agentGroupStore: AgentGroupStore,
  messageWidgetsStore: MessageWidgetsStore,
  topicStore: TopicStore,
  featuresStore: FeaturesStore,
  tagGroupRulesStore: TagGroupRulesStore,
  guestStore: GuestStore,
  usersStore: UsersStore
});

export interface RootStoreEnv extends SharedRootStoreEnv, AgentServices {
  spinnerService: SpinnerService;
  userActivityService: UserActivityService;
  ringtoneService: RingtoneService;
  pluginService: PluginService;
  callService: AgentCallService;
}

export const useStore = (): IRootStore => {
  const store = useContext(MobXProviderContext);

  if (!store) {
    throw new Error("useStore must be used withing a StoreProvider");
  }

  return store as IRootStore;
};

// create and export interfaces

export interface IRootStore extends Instance<typeof RootStore> {}

/** Verify agent root store model extends shared store
 * ideally this could be verified directly in root store model
 */
// ignore unused function
// @ts-ignore
const checkThatRootStoreExtendsSharedRootStore = (t: IRootStore) => {
  extendsSharedRootStore(t);
};
